export default __webpack_public_path__ + "static/media/image 160.32ac9c25.png";